import * as React from "react";
import { useState, useCallback } from "react";
import styled from "styled-components";
import { useQueryClient } from "@tanstack/react-query";
import { DEFAULT_PAGINATION } from "components/common/PaginatedItemOverview";
import { PaginatedItemOverview, ShareButton } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import UsersQueryHelper from "components/users/UsersQueryHelper";
import EntityShareModal from "components/permissions/EntityShareModal";
import UsersSelector from "./UsersSelector";
import TeamsDomain from "../../domainActions/TeamsDomain";
import { teamQueryKey } from "../../hooks/useTeam";
import { TEAM_MEMBERS_BY_ROLE_QUERY_KEY } from "../../logic/useTeamMembersByRole";
const Container = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;
const UsersSection = ({ team: { id, name }, team }) => {
  const [loading, setLoading] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [paginatedUsers, setPaginatedUsers] = useState();
  const queryClient = useQueryClient();
  const _onLoad = useCallback(
    (pagination) => {
      setLoading(true);
      return TeamsDomain.loadUsersForTeam(id, name, pagination).then((response) => {
        setLoading(false);
        return response;
      });
    },
    [id, name]
  );
  const _onAssignUser = (users) => TeamsDomain.addMembers(
    id,
    users.map((u) => u.id)
  ).then(() => {
    queryClient.invalidateQueries({ queryKey: teamQueryKey(id) });
    queryClient.invalidateQueries({ queryKey: TEAM_MEMBERS_BY_ROLE_QUERY_KEY });
    return _onLoad(DEFAULT_PAGINATION).then(setPaginatedUsers);
  });
  const _onUnassignUser = (user) => {
    if (window.confirm(`Do you really want to remove the user "${user.fullName}" from this team?`)) {
      TeamsDomain.removeMember(id, user.id).then(() => {
        queryClient.invalidateQueries({ queryKey: teamQueryKey(id) });
        queryClient.invalidateQueries({ queryKey: TEAM_MEMBERS_BY_ROLE_QUERY_KEY });
        _onLoad(DEFAULT_PAGINATION).then(setPaginatedUsers);
      });
    }
  };
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: "Users",
      showLoading: loading,
      headerActions: /* @__PURE__ */ React.createElement(ShareButton, { entityId: id, entityType: "team_users", onClick: () => setShowShareModal(true) })
    },
    /* @__PURE__ */ React.createElement("h3", null, "Assign Users"),
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(UsersSelector, { onSubmit: _onAssignUser, team })),
    /* @__PURE__ */ React.createElement("h3", null, "Selected Users"),
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
      PaginatedItemOverview,
      {
        noDataText: "No selected users have been found.",
        onLoad: _onLoad,
        overrideList: paginatedUsers,
        queryHelper: /* @__PURE__ */ React.createElement(UsersQueryHelper, null),
        onDeleteItem: _onUnassignUser
      }
    ), showShareModal && /* @__PURE__ */ React.createElement(
      EntityShareModal,
      {
        entityId: id,
        entityType: "team_users",
        entityTypeTitle: "Team Members",
        entityTitle: name,
        description: "Search for a User or Team to add as collaborator on this team's members.",
        onClose: () => setShowShareModal(false)
      }
    ))
  );
};
export default UsersSection;
